import React from 'react';
import '../styles/App.css';

const Loader = () =>
  <div className="spinner">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>;

export default Loader;
